export const directoryPl = {
  directory: {
    export: {
      title: 'Eksport adresów e-mail',
      subtitle: 'Filtruj osoby i skopiuj ich adresy do wklejenia w kliencie poczty',
      accessDenied: 'Nie masz roli w organizacji uprawniającej do eksportu adresów.',
      filters: 'Filtry',
      region: 'Region',
      role: 'Rola / służba',
      group: 'Grupa',
      noOptions: 'Brak opcji',
      search: 'Szukaj',
      results: 'Wyniki',
      resultCount: '{count} adresów',
      empty: 'Brak wyników — zastosuj filtry lub dodaj ręcznie',
      addPerson: 'Dodaj osobę',
      addEmail: 'Dodaj dowolny e-mail',
      personHasNoEmail: 'Ta osoba nie ma adresu e-mail',
      invalidEmail: 'Nieprawidłowy adres e-mail',
      copyPlain: 'Kopiuj same adresy',
      copyLabeled: 'Kopiuj z etykietami',
      copied: 'Skopiowano do schowka',
    },
    persons: {
      title: 'Przeglądarka osób',
      subtitle: 'Przeglądaj, edytuj i scalaj duplikaty osób w Twoim zasięgu',
      accessDenied: 'Nie masz roli w organizacji uprawniającej do przeglądarki osób.',
      searchPlaceholder: 'Szukaj po imieniu, nazwisku, e-mailu, telefonie...',
      empty: 'Brak osób',
      editTitle: 'Edytuj osobę',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      email: 'E-mail',
      phone: 'Telefon',
      updated: 'Zapisano zmiany',
      groupBadge: 'Grupa: {name}',
      mergeLabel: 'Scal z inną osobą (duplikat)',
      mergeButton: 'Scal',
      mergeConfirm: 'Scalić {duplicate} w {keep}? Ta operacja jest nieodwracalna: wszystkie przypisania służby i członkostwa w grupach zostaną przeniesione, a {duplicate} zostanie usunięty.',
      merged: 'Osoby scalone',
    },
  },
}
